// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1ivLn","vLegacy":"SelectSecondary_vLegacy__1ITzw","error":"SelectSecondary_error__3GUn4","disabled":"SelectSecondary_disabled__3tNB2"};